// advertentie-photo-selection: the hoofdfoto picker's thumbnail bytes. The access token is bearer-only
// (in memory, not a cookie), so a plain <img src> can't carry it — the thumbnail goes through an
// authenticated blob fetch → object URL (mirrors src/api/animalPhoto.ts). The foto-opties list itself is
// plain JSON and is fetched via the Refine dataProvider (useCustom) in the component.
import { getAccessToken } from "../auth";

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "/api";

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/** Fetch one advertisement photo's bytes (authenticated, dier-scoped) as a Blob — for a picker thumbnail. */
export async function fetchAdvertentieFotoBlob(advertentieId: string, afbeeldingId: number): Promise<Blob> {
  const res = await fetch(`${API_URL}/herplaatsing/${advertentieId}/foto/${afbeeldingId}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.blob();
}
